const createSimpleObserver = ({ enable = true } = {}) => {
    let listeners = [];
    const notify = async (value) => Promise.all(listeners.map((listener) => listener(value)));
    const observe = (listener) => {
        if (!enable) {
            throw new Error('observe method is not supported');
        }
        listeners.push(listener);
        return () => {
            listeners = listeners.filter((fn) => fn !== listener);
        };
    };
    return {
        listeners,
        observe,
        notify,
    };
};
export default createSimpleObserver;
